import { Component, Input, forwardRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { CuratorAnalysisButtonFieldModel } from '../../../../Common/PageBuilder/models/curator-analysis-button-field.model';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { BriefingCoverageAnalysisService } from '../../services/briefing-coverage-analysis.service';
import { CuratorBlock } from '../../../../Common/PageBuilder/models/curator-block.model';
import { CuratorDisplayElement } from '../../../../Common/PageBuilder/models/curator-display-element.model';
import { AiAnalysisTypes } from '../../../../Common/Mentions/enums/ai-analysis-types.enum';


@Component({
    selector: 'agpr-curator-analysis-button-field',
    templateUrl: './curator-analysis-button-field.component.html',
    styleUrls: ['./curator-analysis-button-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => CuratorAnalysisButtonFieldComponent)
        }
    ],
    standalone: false
})
export class CuratorAnalysisButtonFieldComponent extends AbstractFormFieldComponent implements OnInit{
    readonly buttonTypes = ButtonTypesEnum;
    readonly aiAnalysisTypes = AiAnalysisTypes;
    @Input() declare field: CuratorAnalysisButtonFieldModel;

    generateOnSend: boolean;
    displayElement: CuratorDisplayElement;

    constructor(
        private briefingCoverageAnalysisService: BriefingCoverageAnalysisService
    ) {
        super();
    }

    ngOnInit(): void {
        this.displayElement = this.block?.displayElement as CuratorDisplayElement;
        this.generateOnSend = !!this.displayElement?.generateOnSend;
    }

    curatorAnalyze(): void {
        this.briefingCoverageAnalysisService.curatorAnalyze(this.block as CuratorBlock);
    }

    resetCurator(): void {
        this.briefingCoverageAnalysisService.resetCurator(this.block as CuratorBlock);
    }

    setupValue() {
        const curatorBlock = this.block as CuratorBlock;
        this.value = this.generateOnSend;

        if (this.generateOnSend && this.displayElement.hasGeneratedContent) {
            curatorBlock.blocks = curatorBlock.originalBlocks;
            this.displayElement.hasGeneratedContent = false;
            curatorBlock.originalBlocks = [];
        }

        if (this.generateOnSend) {
            curatorBlock.errors = [];
        }

        this.changes.emit(this.value);
    }
}
